// Vite entrypoint
console.log("Vite ⚡️ Ruby")

import Rails from "@rails/ujs"
Rails.start()

import * as Turbo from "@hotwired/turbo"
Turbo.session.drive = false

// --------------------
// CSS / Assets
// --------------------
import "../sass/smartapp.scss"
import "../webfonts/smartadmin/sa-icons.scss"
import "../webfonts/fontawesome/fontawesome.scss"
import {saveSettings} from "../scripts/core/saveloadscript"

const layoutObserver = new MutationObserver(() => {
    saveSettings();
});

layoutObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-bs-theme', 'data-menu-hub-layout']
});

document.addEventListener("turbo:load", () => {
    const saved = JSON.parse(localStorage.getItem('layoutSettings') || '{}');
    if (saved.theme) {
        document.documentElement.setAttribute('data-bs-theme', saved.theme);
    }
});


// --------------------
// jQuery (global)
// --------------------
import $ from "jquery"
window.$ = $
window.jQuery = $

// --------------------
// ApexCharts (SmartAdmin wrapper expects globals)
// --------------------
import ApexCharts from "apexcharts"

// Alguns wrappers do SmartAdmin esperam "OriginalApexCharts" e/ou "ApexCharts" no window
window.OriginalApexCharts = ApexCharts
window.ApexCharts = ApexCharts

// --------------------
// DataTables
// --------------------
import "datatables.net-bs5"
import "datatables.net-bs5/css/dataTables.bootstrap5.css"

// --------------------
// Flatpickr
// --------------------
import "flatpickr/dist/flatpickr.min.css"

// --------------------
// Stimulus
// --------------------
import {Application} from "@hotwired/stimulus"
import {registerUiComponents} from "ui_components"

const application = Application.start()

// --------------------
// 🔹 Controllers da APP
// --------------------
const controllers = import.meta.glob(
    "../../app/javascript/controllers/**/*_controller.js",
    {eager: true}
)

for (const path in controllers) {
    const controller = controllers[path]
    const name = path
        .split("/")
        .pop()
        .replace("_controller.js", "")
        .replace(/_/g, "-")

    application.register(name, controller.default)
}

// --------------------
// 🔹 Controllers da GEM
// --------------------
registerUiComponents(application)

// -------------------------
// Ativar Tooltips Bootstrap
// -------------------------
document.addEventListener("turbo:load", () => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltipTriggerList.forEach(el => new bootstrap.Tooltip(el))
})

// ----------------------------------------
// Ativar Toastr para notificações globais
// ----------------------------------------

import toastr from "toastr"
import "toastr/build/toastr.min.css"

window.toastr = toastr

toastr.options = {
    closeButton: true,
    progressBar: true,
    newestOnTop: true,
    preventDuplicates: true,
    positionClass: "toast-top-right",
    timeOut: 4000,
}

// ----------------------------------------
// Busca em selects com TomSelect
// ----------------------------------------
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.css"

window.TomSelect = TomSelect
